import React from 'react'
import * as UI from 'ui'
import Smartview from 'widgets/smartviews/Smartview'
import {
  Collection,
  ForEachModel,
  WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty, WhenLoaded
} from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import ShiftExchangeEntry from '../ShiftExchangeEntry'
import { SelectedDepartmentFilter } from '../../../../../../support/filters'

export default function ManageShiftExchangesSmartview () {
  return (
    <Translator namespace='shiftexchange'>
      <Smartview size='4xl' header={<Translation name='headers.exchanges_awaiting_approval' />}>
        <Collection resourceName='shifts.exchange' operationName='manageable' operationContext={{ context: 'smartview' }}>
          <SelectedDepartmentFilter />
          <WhenLoaded>
            <WhenCollectionIsEmpty>
              <Translation name='status.no_exchanges_awaiting_approval' />
            </WhenCollectionIsEmpty>
            <WhenCollectionIsNotEmpty>
              <UI.VerticalList>
                <ForEachModel>
                  <ShiftExchangeEntry />
                </ForEachModel>
              </UI.VerticalList>
            </WhenCollectionIsNotEmpty>
          </WhenLoaded>
        </Collection>
      </Smartview>
    </Translator>
  )
}
